import { CoborrowerEmploymentInfo, PrimaryEmploymentInfo } from '../../cards/employment-info';
import { Branch, Card } from '../../components/deck';
import ExtraIncomeBranch, { FunctionalAreaBranch } from './extra-income';

const employmentInfo = {
  borrower: PrimaryEmploymentInfo,
  coborrower: CoborrowerEmploymentInfo
};

/**
 * Branch in which to track employment type and bonus and commission incomes.
 *
 * @param {*} borrowerKey - primary or coborrower
 */
const EmploymentInfo = (borrowerKey) =>
  Card(
    employmentInfo[borrowerKey],
    Branch(
      {
        bonusOrCommissionBranch: ExtraIncomeBranch(borrowerKey),
        functionalAreaBranch: FunctionalAreaBranch(borrowerKey)
      },
      ({ model }) => {
        // If the user indicates they make a bonus or commission...
        if (model.getIn([borrowerKey, 'commission']) || model.getIn([borrowerKey, 'bonus'])) {
          // If the user already indicated they've been at their job less than a month...
          if (model.getIn([borrowerKey, 'employmentLength']) === false) {
            // ... skip straight to the functional area branch.
            return 'functionalAreaBranch';
          }
          return 'bonusOrCommissionBranch';
        }
        return null;
      }
    )
  );

export default EmploymentInfo;



// WEBPACK FOOTER //
// ./src/decks/branches/employment-info.js